import React, { Component } from 'react'
import { connect } from 'react-redux'
import GetRateSample from '../samples/GetRateSample'
import { makeGetRate } from '../../../actions/mcpActions'
import { _DOTNET, _JAVA, _PHP } from '../../../actions/types'

const CODES = {
    version_number: ["mcpGetRate.SetMCPVersion(\"MCP_VERSION_NUM\");", "getRate.setMCPVersion(\"MCP_VERSION_NUM\");", "'mcp_version'=> $mcp_version"],
    rate_transaction_type: ["mcpGetRate.SetMCPRateTxnType(\"TRANSACTION_TYPE_VALUE\");", "getRate.setRateTxnType(\"TRANSACTION_TYPE_VALUE\");", "'rate_txn_type'=>$rate_txn_type"],
    Rate_Info: ["mpgReq.SetStatusCheck(status_check);", "getRate.setMCPRateInfo(rate);", "$mpgTxn->setMCPRateInfo($mcpRate);"],
    add_cardholder_amount: ["rate.AddCardholderAmount(\"FOREIGN_AMT\", \"FOREIGN_CURRENCY_CODE\");", "rate.addCardholderAmount(\"FOREIGN_AMT\", \"FOREIGN_CURRENCY_CODE\");", "$mcpRate->setCardholderAmount('FOREIGN_AMT', 'FOREIGN_CURRENCY_CODE');"],
    add_merchant_settlement_amount: ["rate.AddMerchantSettlementAmount(\"CAD_AMOUNT\", \"FOREIGN_CURRENCY_CODE\");", "rate.addMerchantSettlementAmount(\"CAD_AMOUNT\", \"FOREIGN_CURRENCY_CODE\");", "$mcpRate->setMerchantSettlementAmount('CAD_AMOUNT', 'FOREIGN_CURRENCY_CODE');"],
}

class GetRate extends Component {
    onMakeGetRatePress() {
        const { storeId, apiToken } = this.props;
        const getRateRequest = { storeId, apiToken };
        this.props.makeGetRate(getRateRequest);
    }

    renderIntegrationTool() {
        return (
            <div className="stepMainContainer">
                <h3>Sample Force Post</h3>
                <GetRateSample />
                <div className="requestButton" onClick={() => this.onMakeGetRatePress()}>
                    Get Rate Request
                </div> 
            </div>
        );
    }

    renderDocument() {
        const { progLangId } = this.props;

        return (
            <div className="stepPageContainer">
                <span className="stepPageTitle"><b>MCP Get Rate</b></span>
                <p style={{marginTop: '3vh'}}>Performs a foreign currency exchange rate look-up, and secures that exchange rate for use in a subsequent MCP financial transaction.</p>
                <p>The exchange rate retrieved by this transaction request is represented in the response as the RateToken, and the underlying exchange rate is locked in for a limited time period.</p>

                <p><b>MCP Get Rate transaction object definition</b></p>
                {(() => {
                switch(progLangId) {
                    case _DOTNET:
                        return  <code>MCPGetRate mcpGetRate = new MCPGetRate();</code>
                    case _JAVA:
                        return <code>MCPGetRate getRate = new MCPGetRate();</code>
                    case _PHP:
                        return <code>$txnArray = array(‘type’=>’mcp_get_rate', …);<br />$mpgTxn = new mpgTransaction($txnArray);</code>
                    default:
                        return null
                    }
                })()}

                <p style={{ marginTop: '5vh'}}><b>HttpsPostRequest object for MCP Get Rate transaction</b></p>
                {(() => {
                switch(progLangId) {
                    case _DOTNET:
                        return <code>HttpsPostRequest mpgReq = new HttpsPostRequest();<br />mpgReq.SetTransaction(mcpGetRate);</code>
                    case _JAVA:
                        return <code>HttpsPostRequest mpgReq = new HttpsPostRequest();<br />mpgReq.setTransaction(getRate);</code>
                    case _PHP:
                        return <code>$mpgRequest = new mpgRequest($mpgTxn);<br />$mpgHttpPost = new mpgHttpsPost($store_id,$api_token,$mpgRequest);</code>
                    default:
                        return null
                    }
                })()}

                <h3 style={{ marginTop: '7vh'}}>MCP Get Rate transaction request fields – Required</h3>
                <table>
                    <th>Variable Name</th>
                    <th>Type and Limits</th>
                    <th>Set Method</th>

                    <tr>
                        <td>MCP version number</td>
                        <td><i>String</i><br /><br />numeric<br /><br />current version is 1.0</td>
                        <td><code>{CODES.version_number[progLangId]}</code></td>
                    </tr>

                    <tr>
                        <td>rate transaction type</td>
                        <td><i>String</i><br /><br />1-character alphabetic</td>
                        <td><code>{CODES.rate_transaction_type[progLangId]}</code></td>
                    </tr>
                    <tr>
                        <td>MCP Rate Info</td>
                        <td><i>Object</i><br /><br />N/A</td>
                        <td><code>{CODES.Rate_Info[progLangId]}</code></td>
                    </tr>
                </table>

                <h3 style={{ marginTop: '7vh'}}>MCP Rate Info object request fields</h3>
                <p>At least one of the following variables must be sent:</p>
                <table>
                    <th>Variable Name</th>
                    <th>Type and Limits</th>
                    <th>Set Method</th>

                    <tr>
                        <td>add cardholder amount</td>
                        <td><i>String array</i><br /><br />12-character numeric, 3-character numeric<br /><br />(smallest discrete unit of foreign currency, currency code)</td>
                        <td><code>{CODES.add_cardholder_amount[progLangId]}</code></td>
                    </tr>
                    <tr>
                        <td>add merchant settlement amount</td>
                        <td><i>String array</i><br /><br />12-character numeric, 3-character numeric<br /><br />(amount in CAD pennies, currency code)</td>
                        <td><code>{CODES.add_merchant_settlement_amount[progLangId]}</code></td>
                    </tr>
                </table>
            </div>
        );
    }

    render() {
        const { mode } = this.props;
        if(mode === 'interactive_tool')
            return this.renderIntegrationTool();
        else if(mode === 'integration_guide')
            return this.renderDocument();
        else {
            return null;
        }
    }
}

const mapStateToProps = state => {
    const { mode } = state.common.sideNav;
    const { storeId, apiToken } = state.mcp.main.config;
    return { mode, storeId, apiToken, progLangId: state.common.progLangList.selection };
}

export default connect(mapStateToProps, {makeGetRate})(GetRate)
